import React, {Component} from 'react';
import '../../pages/settingsPage/SettingsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import models from '../../model/models';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';
import DrugTypeCard from '../../cards/drugTypeCard/DrugTypeCard';
import SettingsTabBar from '../../components/settingsTabBar/SettingsTabBar';

export default class AvailableDrugsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user_group: {},
			drug_types: [],
		};
	}

	componentDidMount = async () => {
		this.subscribeId = models.user_group.onChange(this._getData);
		await this._getData();
	};

	componentWillUnmount = () => {
		if (this.subscribeId) {
			models.user_group.unsubscribe(this.subscribeId);
		}
	};

	_getData = async () => {
		let drug_types = await mainAPI.drug_type.all_with_allowed();
		let user_group = models.user_group.obj();
		if (!user_group) return;
		await userGroupSettingsManager.refresh(user_group.id);
		this.setState({user_group, drug_types});
	};

	render() {
		return (
			<Page className="g-settings-page">
				<Card>
					<Label larger black>
						Account settings
					</Label>
					<div className="lower">
						<SettingsTabBar userGroup={this.state.user_group} />
						<DrugTypeCard
							className="inner-card drugs-list"
							userGroup={this.state.user_group}
							drugTypes={this.state.drug_types}
						/>
					</div>
				</Card>
			</Page>
		);
	}
}




// WEBPACK FOOTER //
// ./src/pages/availableDrugsPage/AvailableDrugsPage.jsx